import headShot from "../Assets/me2.jpeg";
import {Link} from "react-router-dom";
import { TypeAnimation } from 'react-type-animation';


export default function HeroCard(){
    return(
        <div className="flex lg:justify-center max-h-[35vh]">
            <div className="flex flex-col items-center justify-center lg:w-[50%]">
                <Link to="/About">
                    <img
                        src={headShot}
                        alt="headshot"
                        className="h-[15vh] lg:h-[25vh] rounded-full lg:hidden mb-4 scale-110"
                    />
                </Link>
                <TypeAnimation
                    sequence={["Hi, I'm Lander"]}
                    speed={1}
                    cursor={false}
                    repeat={0}
                    wrapper="span"
                    className="font-bold text-3xl text-center text-[#6C5F5B]"
                />
                <p className="text-l lg:w-[75%] text-center">Full-stack .NET & React developer focused on building clean, high-performance apps that solve real business problems.</p>
            </div>
            <Link to="/About">
                <div className="relative group cursor-pointer h-[15vh] lg:h-[25vh] hidden lg:block">
                    <img
                        src={headShot}
                        alt="headshot"
                        className="h-[15vh] lg:h-[25vh] lg:block hidden rounded-full"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity rounded-full">
                        <p className="text-white font-bold">Who's this?</p>
                    </div>
                </div>
            </Link>
        </div>
    )
}